import styled from '@emotion/styled'
import { colors } from '@mobi/component-library/Foundations'
import { greaterOrEqualThan, type Breakpoint } from '@mobi/component-library/Utils/media'

export const AppHeaderLogoLinkStyled = styled.a({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  boxSizing: 'border-box',
  fontSize: '3rem',
  textDecoration: 'none',
  userSelect: 'none',

  padding: 0,
  width: 'auto',
  color: colors.white,
})

type logoProps = {
  compactBreakpoint: keyof typeof Breakpoint
}

export const AppHeaderLogoFullStyled = styled('span')(
  ({ compactBreakpoint = 'px350' }: logoProps) => ({
    display: 'none',

    [greaterOrEqualThan(compactBreakpoint)]: {
      display: 'flex',
      width: '8rem',
    },
  })
)

export const AppHeaderLogoCompactStyled = styled('span')(
  ({ compactBreakpoint = 'px350' }: logoProps) => ({
    display: 'block',
    minWidth: '4rem',

    [greaterOrEqualThan(compactBreakpoint)]: {
      display: 'none',
    },
  })
)
